/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Toast_Save_FailedInputs */

const vi_station_voice_toast_save_failed = /** @type {(inputs: Station_Voice_Toast_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu cấu hình thất bại`)
};

/**

* @param {Station_Voice_Toast_Save_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_toast_save_failed = /** @type {((inputs?: Station_Voice_Toast_Save_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Toast_Save_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_toast_save_failed(inputs)
});